export interface HolidayInfoPopupProps {
  top: number;
  left: number;
  holidayName: string;
}

const HolidayInfoPopup = (props: HolidayInfoPopupProps) => {
  const { top, left, holidayName } = props;

  const style = {
    position: "fixed" as const,
    top,
    left,
    zIndex: 20,
    userSelect: "none" as const,
    pointerEvents: "none" as const,
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    backgroundColor: "rgba(255, 255, 255, 0.98)",
    color: "#111827",
    border: "1px solid rgba(248, 113, 113, 0.55)",
    borderRadius: "999px",
    padding: "6px 10px 6px 8px",
    boxShadow: "0 8px 22px rgba(15, 23, 42, 0.12)",
    fontSize: "0.82rem",
    fontWeight: 600,
    lineHeight: 1.2,
    maxWidth: "240px",
    backdropFilter: "blur(6px)",
  };

  const labelStyle = {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    minWidth: "22px",
    height: "22px",
    padding: "0 6px",
    borderRadius: "999px",
    backgroundColor: "#fee2e2",
    border: "1px solid #fca5a5",
    fontSize: "0.64rem",
    fontWeight: 700,
    letterSpacing: "0.08em",
    textTransform: "uppercase" as const,
    color: "#dc2626",
  };

  const textStyle = {
    color: "#111827",
    whiteSpace: "nowrap" as const,
    overflow: "hidden",
    textOverflow: "ellipsis",
  };

  return (
    <div id="HolidayInfoPopup" style={style}>
      <span style={labelStyle}>JF</span>
      <div style={textStyle}>{holidayName}</div>
    </div>
  );
};

export default HolidayInfoPopup;
